import { layout_children, bigScreen_layout_children, app_layout_children } from "./menus/index"
import { emptylayout_children,app_emptylayout_children } from "dependencies/emptyLayout/index.js"
const layoutComponent = {
  name: "layoutComponent",
  desc: "自由布局",
  render: () => import("./render/index.vue"),
  optDes: null,
  enable: true,
  menus: {
    app: [
      {
        name: "布局",
        children: app_emptylayout_children,
        group: "highLevel",
        sort: 70,
        enable(params) {
          let homePageBusinessFlag = true
          if ("homePageBusinessFlag" in params && params.homePageBusinessFlag === false) {
            homePageBusinessFlag = false
          }
          return homePageBusinessFlag
        },
      }
    ],
    bigScreen: [
      {
        name: "自由布局",
        children: bigScreen_layout_children
      }
    ],
    portal: [
      {
        name: "自由布局",
        children: emptylayout_children,
        group: "highLevel",
        sort: 70,
        enable(params) {
          let homePageBusinessFlag = true
          if ("homePageBusinessFlag" in params && params.homePageBusinessFlag === false) {
            homePageBusinessFlag = false
          }
          return homePageBusinessFlag
        },
      }
    ]
  },
  toolbars: [
    {
      name: "layoutComponent",
      label: "自由布局"
    }
  ]
}

export default layoutComponent
